import { render, staticRenderFns } from "./UserTheme.vue?vue&type=template&id=be4b6128&scoped=true&"
import script from "./UserTheme.vue?vue&type=script&lang=js&"
export * from "./UserTheme.vue?vue&type=script&lang=js&"
import style0 from "./UserTheme.vue?vue&type=style&index=0&id=be4b6128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4b6128",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be4b6128')) {
      api.createRecord('be4b6128', component.options)
    } else {
      api.reload('be4b6128', component.options)
    }
    module.hot.accept("./UserTheme.vue?vue&type=template&id=be4b6128&scoped=true&", function () {
      api.rerender('be4b6128', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/form/theme/components/UserTheme.vue"
export default component.exports